module.exports = __webpack_public_path__ + "media/images/apps/google-play-5093468f9e9f4ab7f05473515518ed5e.png";